<template>
  <div class="wrap productItem">
    <div class="header">
      <NavBar
        title="Item"
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      >
        <span v-if="isLogin" slot="right" icon="cart-o"
          ><Icon name="cart-o" size="0.7rem" @click="toCat" :badge="count"
        /></span>
      </NavBar>
    </div>
    <div class="main">
      <div class="my-video">
        <van-swipe   ref="goods_swipe" class="goods-swipe" @change="onChange">
          <van-swipe-item v-for="(item, index) in imgList" :key="index">
            <van-image :src="toPicProductImg(item)" fit="cover" />
            <!-- <van-image :src="item.image"   /> -->
          </van-swipe-item>
          <van-swipe-item  v-if="this.playerOptions.sources[0].src">
            <video-player
              class="goods-video"
              ref="videoPlayer"
              :options="playerOptions"
            ></video-player>
          </van-swipe-item>
          <div class="swipe-item-category" slot="indicator">
            <span class="text" :class="{ ac: current != imgList.length }"
              >Picture</span
            >
            <span v-if="this.playerOptions.sources[0].src"  class="text" :class="{ ac: current == imgList.length }"
              >Video</span
            >
          </div>
          <div
            class="custom-indicator"
            slot="indicator"
            v-show="current != imgList.length"
          >
            <div class="p-c">
              <span class="current">{{ current + 1 }}</span
              >/{{ imgList.length }}
            </div>
          </div>
        </van-swipe>
      </div>
      <!-- <van-swipe :autoplay="3000" @change="onChange">
        <van-swipe-item v-for="(image, index) in imgList" :key="index">
          <div class="luoboBox">
            <img v-lazy="image" />
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{imgList.length}}</div>
        </template>
      </van-swipe> -->

      <div class="IBox" v-if="productEntity">
        <div class="title">{{ productEntity.productName }}</div>
        <div class="FlexBox Rates">
          <!-- 有评论展示 -->
          <div v-if="productEntity.avgStar">
          <Rate
            allow-half
            readonly
            v-model="productEntity.avgStar"
            :size="20"
          />
          </div>
          <div class="avgStarCount" v-if="productEntity.avgStar" @click="toComment">
            <span class="">{{ productEntity.count }} </span>product
            ratings
          </div>
           <!-- 无评论展示 -->
          <div class="Nostars" v-else>No Review Yet</div>
        </div>
        <div class="FlexBox price">
          <div v-if="productEntity.parUnion == 0">
            <span class="pd5 priceLeft">${{ productEntity.discountPrice }}</span>
            Save : ${{ productEntity.earnMoney }} <span>({{discount}})</span>
          </div>
          <div v-else>
            <span class="pd5 priceLeft">${{ productEntity.nomalPrice}}</span>
          </div>
          <div></div>
          <div>
            <Tag
              v-if="productEntity.fare == 0"
              plain
              color="#16C7CE"
              text-color="#16C7CE"
              >Free Shipping</Tag
            >
            <!-- <Tag plain type="danger">Free Shipping</Tag> -->
          </div>
        </div>
        
        <div v-if="productEntity.parUnion == 0" style="color:#9BA1AA;text-decoration:line-through">
          ${{ productEntity.nomalPrice }}
        </div>
        <div class="depict">{{ productEntity.depict }}</div>
        <div class="line"></div>
        <div v-if="productEntity.relationProduct" style="margin-bottom:20px">
          <div class="FlexBox CheckItem">
            <Checkbox v-model="checked" icon-size="18px" /><span
              >Indoor Panel Antenna Expansion Kit</span
            >
          </div>
          <div>{{productEntity.relationProduct}}</div>
        </div>
        <Button color="#16C7CE" type="primary" @click="toOrder" block
          >Buy Now</Button>
        <Button
          class="cartBtn"
          plain
          type="primary"
          block
          @click="AddCat"
          >Add to Cart</Button
        >
      </div>
      <div class="Separate"></div>

      <div class="IBox" v-if="productEntity">
        <div @click="toImgList" class="title">Product Information</div>
        <div>
          <div>BasicInfo</div>
          <div class="bandItemText" v-html="BasicInfo">
            <!-- {{ productEntity.basicInfo }} -->
          </div>
        </div>
        <div style="margin:20px 0">
          <div>Features</div>
          <div class="bandItemText" v-html="Features">
            <!-- {{ productEntity.featureTag }} -->
          </div>
        </div>
      </div>
      <div class="Separate"></div>

      <div class="IBox">
        <Collapse v-model="activeName" accordion>
          <!-- 质保与服务 -->
          <CollapseItem title="Warranty & Returnrn" name="1">
            <div class="HelpBtn" @click="toProtocol(3)">3-Year Warranty</div>
            <div class="HelpBtn" @click="toProtocol(30)">30-Day Money Back Guarantee</div>
          </CollapseItem>
          <!-- 帮助与支持 -->
          <CollapseItem title="Help & Resource" name="2">
            <div class="HelpBtn" v-if="this.playerOptions.sources[0].src" @click="toHelp(1)">video</div>
            <template v-if="productEntity.productFileEntity.helpManual">  
              <a  :href = 'downloadExcelUrl'  target="_blank" class="HelpBtn">User Manual</a>
            </template>
            <!-- <div  class="HelpBtn">Installation Guide</div> -->
            <template v-if="productEntity.productFileEntity.helpSheet">  
              <a :href = 'downloadExcelUrl2'  target="_blank" class="HelpBtn">User Manual</a>
            </template>
            <!-- <div @click="toHelp(3)">Spec sheet</div> -->
          </CollapseItem>
          <!-- 产品分类 -->
          <CollapseItem title="Product" name="3">
            <div v-for="item in SeriesList" :key="item.categoryId">
              <div class="HelpBtn" @click="toCategory(item)">{{ item.categoryName }}</div>
            </div>
          </CollapseItem>
          <!-- 联系我们 -->
          <CollapseItem title="Contact Us" name="4">
            <div>(972) 870-5666</div>
            <div>Customer Support at support@hiboost.com</div>
            <div>Technical Support at service@hiboost.com</div>
            <div>Business cooperation at marketing1@huaptec.com</div>
          </CollapseItem>
        </Collapse>
      </div>
      <div class="Separate"></div>

      <div class="IBox" v-if="likeData">
        <div class="title">You Might Also Like</div>
        
      </div>
      <div class="listBox" v-if="likeData" >
        <div class="listScroll">
          <div
            class="listItem"
            v-for="item in likeData.productEntityList"
            :key="item.productId"
          >
            <!-- <img src="../../../public/img/REFERRALbg.png" alt=""> -->
            <div @click="toElseDetal(item)">
              <div class="imgBox2">
                <VanImage
                  :src="toPicProductImg(item.productFileEntity.mainImg)"
                  lazy-load />
              </div>
              <div class="listText">
                <div class="productName ellipsis"><span>{{ item.productName }}</span></div>
                <div class="LikeBasicInfo">{{ item.basicInfo }}</div>
                <!-- 联盟商品 -->
                <div class="PriceBox" v-if="item.parUnion == 0">
                  <span class="discountPrice" >${{ item.discountPrice }}</span>
                  <span class="nomalPrice">${{ item.nomalPrice }}</span>
                </div>
                <!-- 非联盟商品 -->
                <div class="PriceBox" v-else>
                  <span class="discountPrice" >${{ item.nomalPrice }}</span>
                </div>
                <!-- <div v-if="item.avgStar">
                  <Rate allow-half readonly v-model="item.avgStar" :size="20" />
                </div>
                <div class="Nostars" v-else>No Review Yet</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部公共组件 -->
      <Footer />
    </div>
  </div>
</template>
<script>
import {httpUrl, baseUrl} from "../../api/config";
import Footer from "@/components/footer";
import request from "../../api/request";
import { toPicProductImg } from "../../utils/common";
import { getStore } from "../../utils/storage";
import { Notify, Toast } from "vant";
export default {
  components: { Footer },
  data() {
    return {
      BasicInfo:'',
      Features:'',
      SeriesList: [], //系列列表
      likeData: null, //猜你喜欢
      count: null, //购物车商品数
      discount: 0,
      productEntity: null, //单品详情
      current: 0, // 0视频，!0图片
      playerOptions: {
        // poster: 'https://api.btstu.cn/sjbz/api.php?lx=meizi', //视频封面图
        sources: [
          {
            type: "video/mp4", //视频格式
            // src:"http://192.168.3.141:1806/cms/oss/file/tmpUrl/SbyHUmuHtI2N"
            src:"https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4" //视频地址
          }
        ]
      },
      imgList: [
        { image: "https://api.btstu.cn/sjbz/api.php?lx=meizi" },
        { image: "https://api.btstu.cn/sjbz/api.php?lx=suiji" },
        { image: "https://api.btstu.cn/sjbz/api.php?lx=fengjing" }
      ],
      value: 1,
      checked: true,
      activeName: "1",
      isLogin: getStore("user")
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    downloadExcelUrl(){
      return this.toPicProductImg(this.productEntity.productFileEntity.helpManual)
    },
    downloadExcelUrl2(){
      return this.toPicProductImg(this.productEntity.productFileEntity.helpSheet)
    }
  

  },
  created() {
    this.getxlList();
    if (this.isLogin) {
      this.getCatNum(); //获取购物车数量
    }
    this.getItem();
    this.getDiscount()
  },
  methods: {
    toPicProductImg,
    toProtocol(num){ // 跳转协议页
      let src
      if(num == 3){
        // src = 'http://192.168.1.71:7115/protocol/3years.html'
        src = httpUrl+'protocol/3years.html'
      }else if(num == 30){
        // src = 'http://192.168.1.71:7115/protocol/30days.html'
        src = httpUrl+'protocol/30days.html'
      }
      window.open(src,"_blank")
    },
    toImgList(){
      this.$router.push({
        path: "imgList",
        query: {
          productId: this.productEntity.productId
        }
      });
    },
    toComment(){
      this.$router.push({
        path: "/product/help/comment",
        query: {productId: this.productEntity.productId}
      })
    },
    toHelp(num) {
      if(num == 1){
        this.$router.push({
          path: "/product/help/video",
          query: { cid: this.$route.query.id }
        });
      }else if(num == 2){
        this.toPicProductImg(this.productEntity.productFileEntity.helpManual)
        // console.log(this.productEntity.productFileEntity.helpManual)
         
      }else if(num == 3){
        this.toPicProductImg(this.productEntity.productFileEntity.helpSheet)
        // console.log(this.productEntity.productFileEntity.helpSheet)
      }
      // this.$router.push('/product/help/video')
    },
    toCategory(item){
      this.$router.push({
        path: "/categoryList",
        query: {
          categoryId : item.categoryId 
        }
      });
    },
    getDiscount(){
      request("get", "cms/product/getDiscount").then(res => {
        if (res.code === 200) {
          this.discount = res.data.discount;
        }
      });
    },
    toOrder() {
      // console.log(this.productEntity) 
      // return
      this.$router.push({
        path: "/order",
        query: {
          productId: this.productEntity.productId
        }
      });
    },
    toElseDetal(item){
      this.$router.push({
        path: "/productItem",
        query: {
          id: item.productId
        }
      });
      location.reload();
    },
    toCat() {
      if (this.isLogin) {
        this.$router.push("/cat");
      } else {
        this.$router.push("/login");
      }
    },
    getCatNum() {
      //查询购物车商品数
      request("get", "cms/ordercart/getCount").then(res => {
        if (res.code === 200) {
          this.count = res.data;
        }
      });
    },
    getxlList() {
      request("get", "cms/category/queryCategoryClass").then(res => {
        if (res.code === 200) {
          this.SeriesList = res.data;
          // console.log(this.SeriesList)
        }
      });
    },
    AddCat() {
      //加入购物车
      if (this.isLogin) {
        let data = {
          price: this.productEntity.parUnion == 0?this.productEntity.discountPrice:this.productEntity.nomalPrice,
          productId: this.productEntity.productId
        };
        request("put", "cms/ordercart/addCart", data).then(res => {
          if (res.code === 200) {
            this.getCatNum();
            Notify({ type: "success", message: "Added successfully" });
          }
        });
      } else {
        this.$router.push("/login");
      }
    },
    getItem() {
      let data = { productId: this.$route.query.id, page: 1, limit: 10 };
      request("get", "cms/product/queryAssignProOrDetail", data).then(res => {
        if (res.code === 200) {
          this.productEntity = res.data;
          this.BasicInfo = this.productEntity.basicInfo.replace(/\n/g,"<br/>")
          this.Features = this.productEntity.featureTag.replace(/\n/g,"<br/>")
          let imgALL  =  res.data.productFileEntity.mainImg +',' + res.data.productFileEntity.sugImg
          this.imgList = imgALL.split(",");
          this.playerOptions.sources[0].src = this.toPicProductImg(
            res.data.productFileEntity.sugVideo
          );
          this.$forceUpdate()
          this.getLike();
        }
      });
    },
    getLike() {
      //推荐列表猜你喜欢
      let data = {
        productId: this.$route.query.id,
        categoryId: this.productEntity.categoryId
      };
      request("get", "cms/category/queryGuessYouLike", data).then(res => {
        if (res.code === 200) {
          this.likeData = res.data;
        }
      });
    },
    onChange(index) {
      this.current = index; // index：0视频，！0图片
      this.player.pause(); // 滑动后暂停播放
      // this.current = index;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../utils/css/video";
.productItem {
  font-size: 14px;
  .luoboBox {
    width: 100%;
    height: 200px;
    img {
      width: 100%;
      max-height: 100%;
      // object-fit: cover;
    }
  }
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
  }
  .IBox {
    text-align: left;
    padding: 0 10px;
    background: #fff;
    .title {
      font-size: 20px;
      font-weight: bold;
      line-height: 48px;
      text-align: left;
    }
    .Rates {
      justify-content: start;
      align-items: center;
      margin-bottom: 10px;
      .avgStarCount{
        color:#4181ff;
        font-size: 15px;
        margin-left: 15px;
        border-bottom: 1px #4181ff solid;
      }
    }
    .price {
      width: 100%;
      overflow: hidden;
      justify-content: space-between;
      align-items: center;
      .priceLeft {
        padding-right: 10px;
        font-size: 15px;
        color: #e82a2a;
      }
    }
    .bandItemText {
      color: #9ba1aa;
      font-size: 12px;
    }
    .CheckItem {
      margin: 10px 0;
      span {
        padding-left: 15px;
      }
    }
    .HelpBtn{color:#4181FF;padding-bottom: 10px;}
    .depict{
      word-break: break-all;
      margin-top: 10px;
      font-size: 15px;
    }
  }
  .listBox {
    overflow: hidden;
    .listBoxTitle {
      font-size: 15px;
      font-weight: bold;
      padding: 0 0 10px 10px;
      text-align: left;
    }
    .listScroll {
      width: 100%;
      display: flex;
      overflow: scroll;
      margin-bottom: 20px;
    }
    .listItem {
      text-align: left;
      margin-left: 10px;
      padding-bottom: 10px;
      width: 144px;
      border: 1px #D1D4D9 solid;
      .listText {
        padding-left: 5px;
        .productName{
          font-size: 16px;
          font-weight: bold;
        }
        .PriceBox{
          font-size: 15px;

        }
        .LikeBasicInfo{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 1px 0 3px 0;
        }
      }
      .imgBox2 .van-image {
        width: 144px;
        height: 144px;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .pdr5 {
    padding-right: 5px;
  }
  .pdl5 {
    padding-left: 5px;
  }
  .line {
    margin: 20px 0;
    border-bottom: 1px #ccc solid;
  }
}
</style>
<style>
.productItem .van-cell {
  padding-left: 0;
  padding-right: 0;
}
.productItem  .van-rate__item:not(:last-child) {
  padding-right: 2px !important ;
}
.productItem .van-tag--default.van-tag--plain{
  font-size: 10px;
}
.productItem .van-collapse-item__content{
  background: #F6F8FA;
}
.productItem .cartBtn{
  margin: 20px 0;
  color:#16C7CE !important;
  border: 1px #16C7CE solid;
}
</style>
